import { FaHeartbeat, FaHospital, FaBaby, FaListUl } from 'react-icons/fa';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import ProceduresList from './ProceduresLists/ProceduresLists';
import ChartsContainer from '../../Common/ChartsContainer';

const menus = [
    {
        title: 'VDRL',
        path: '/governanceroom/dashboardsihsus/procedures/vdrl',
        icon: <FaHeartbeat />
    },
    {
        title: 'Gestação com Risco',
        path: '/governanceroom/dashboardsihsus/procedures/pregnant',
        icon: <FaBaby />
    },
    {
        title: 'Infecção Hospitalar',
        path: '/governanceroom/dashboardsihsus/procedures/hospital-infection',
        icon: <FaHospital />
    },
    {
        title: 'Ranking',
        path: '/governanceroom/dashboardsihsus/procedures/ranking',
        icon: <FaListUl />
    }
];

const titlesMap = {
    '/governanceroom/dashboardsihsus/procedures/vdrl': 'Tipo de VDRL',
    '/governanceroom/dashboardsihsus/procedures/pregnant': 'Gestação com Risco',
    '/governanceroom/dashboardsihsus/procedures/hospital-infection':
        'Infecção Hospitalar',
    '/governanceroom/dashboardsihsus/procedures/ranking': 'Ranking'
};

export const Procedures = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardsihsus');
    };

    return (
        <div className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <div>
                <ChartsContainer
                    title={titlesMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="vdrl"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle: 'do Tipo de VDRL'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.IND_VDLR,
                                        url: 'governanceroom/dashboard/sihsus/aih/vdrl'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />

                        <Route
                            path="pregnant"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle: 'da Gestação de Risco'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.PREGANT,
                                        url: 'governanceroom/dashboard/sihsus/aih/pregnantRisk'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />
                        <Route
                            path="hospital-infection"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle: 'da Infecção Hospitalar'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.HOSPITAL_INFECTION,
                                        url: 'governanceroom/dashboard/sihsus/aih/hospitalarInfection'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />

                        <Route path="ranking" element={<ProceduresList />} />

                        <Route
                            path="/"
                            element={<Navigate to="vdrl" replace />}
                        />
                    </Routes>
                </ChartsContainer>
            </div>
        </div>
    );
};
